'use strict';

export function findHostInstance(_component: any): void {}
